import { memo } from 'react';
import { Text } from '@library';
import type { Bicycle, ProductVehicle } from '../../../types';
import FeaturedFilter from './FeaturedFilter';
import styles from './FeaturedVehicle.module.css';

const FeaturedVehicle = ({
    vehicle,
    isBicycle = false,
    onClear,
}: {
    vehicle: ProductVehicle | Bicycle;
    isBicycle?: boolean;
    onClear?: () => void;
}) => {
    let manufactureYear: string;

    if (!vehicle.manufacturingStartYear || !vehicle.manufacturingEndYear) {
        manufactureYear = '';
    } else if (
        vehicle.manufacturingStartYear === vehicle.manufacturingEndYear
    ) {
        manufactureYear = `${vehicle.manufacturingStartYear}`;
    } else {
        manufactureYear = `${vehicle.manufacturingStartYear} - ${
            vehicle.manufacturingEndYear !== 0
                ? vehicle.manufacturingEndYear
                : ''
        }`;
    }
    const { typeNumbers } = vehicle as ProductVehicle;

    return (
        <FeaturedFilter
            hideSearchResultsForText
            onClear={onClear}
            value={
                <>
                    <strong>{vehicle.manufacturerName} </strong>
                    <p className={styles.modelLabel}>{vehicle.model}</p>
                </>
            }
            additionalInfo={
                <div className={styles.featuredFilterInfo}>
                    {manufactureYear && (
                        <Text caption primary light>
                            Bj: {manufactureYear}
                            {!isBicycle &&
                                typeNumbers.length > 0 &&
                                ` | ${typeNumbers.join(', ')}`}
                        </Text>
                    )}
                </div>
            }
        />
    );
};

export default memo(FeaturedVehicle);
